export const breakpoints = {
    screen_smallMobile: 576,
    screen_mobile: 768,
    screen_tablet: 992,
    screen_laptop: 1200,
    screen_desktop: 1400
}